import { getString } from "common/uistringlabels/uiStringUtils";

const STRING_PATH = "searchResults.sorting";

export interface SortOption {
  label: string;
  value: string;
}

export interface SortConfig {
  key: string;
  titlePath: string;
  clearPath: string;
  touchpoint: string;
  options: SortOption[];
  isRequired?: boolean;
}

export const getSortConfigs = (): SortConfig[] => {
  const bestMatchLabel = getString(`${STRING_PATH}.bestMatch.relevance`);
  const priceLowToHighLabel = getString(`${STRING_PATH}.price.lowToHigh`);
  const priceHighToLowLabel = getString(`${STRING_PATH}.price.highToLow`);
  const alphabeticAToZLabel = getString(`${STRING_PATH}.alphabetic.aToZ`);
  const alphabeticZToALabel = getString(`${STRING_PATH}.alphabetic.zToA`);

  return [
    {
      key: "bestMatch",
      titlePath: `${STRING_PATH}.bestMatch.title`,
      clearPath: `${STRING_PATH}.bestMatch.clear`,
      touchpoint: "sorting-best-match-option",
      options: [{ label: bestMatchLabel, value: "relevance" }],
      isRequired: true,
    },
    {
      key: "price",
      titlePath: `${STRING_PATH}.price.title`,
      clearPath: `${STRING_PATH}.price.clear`,
      touchpoint: "sorting-price-option",
      options: [
        { label: priceLowToHighLabel, value: "price.amount,asc" },
        { label: priceHighToLowLabel, value: "price.amount,desc" },
      ],
    },
    {
      key: "alphabetic",
      titlePath: `${STRING_PATH}.alphabetic.title`,
      clearPath: `${STRING_PATH}.alphabetic.clear`,
      touchpoint: "sorting-name-option",
      options: [
        { label: alphabeticAToZLabel, value: "name,asc" },
        { label: alphabeticZToALabel, value: "name,desc" },
      ],
    },
  ];
};
